import { useQueryClient, UseQueryResult } from 'react-query'
import { useLocation } from 'react-router-dom'
import { Club } from '@fable/types'
import { getSlug, isUUID } from 'utils'

export const useClub = () => {
  const { pathname } = useLocation()
  const slug = getSlug(pathname)
  const queryClient = useQueryClient()
  const clubData = queryClient.getQueryData<UseQueryResult<any, unknown>>([
    'club',
  ])

  if (!clubData) return null

  let club: Club

  if (!isUUID(slug) && !!clubData?.data?.results) {
    club = clubData?.data?.results[0]
  } else {
    club = clubData?.data as Club
  }

  return club
}
